import { render, staticRenderFns } from "./EducationEventDetails.vue?vue&type=template&id=3f109a91&"
import script from "./EducationEventDetails.vue?vue&type=script&lang=ts&"
export * from "./EducationEventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports